import react, { FC, MutableRefObject } from 'react';
import { SUGGESTION_LIST_TYPE } from '../../IfscCode/types';
import { AutoCompleteContainer, AutoCompleteItem } from './styles';

interface autoCompleteProps {
  text: string;
  suggestions: Array<SUGGESTION_LIST_TYPE>;
  optionsStyle?: react.CSSProperties;
  isComponentVisible: boolean;
  routeToDetails: (item: SUGGESTION_LIST_TYPE) => void;
  refAutocomplete?: MutableRefObject<null>;
}
export const AutoComplete: FC<autoCompleteProps> = ({
  text,
  suggestions,
  isComponentVisible,
  optionsStyle,
  refAutocomplete,
  routeToDetails,
}) => {
  return (
    <>
      {text && suggestions.length > 0 && isComponentVisible && (
        <AutoCompleteContainer
          style={optionsStyle}
          ref={refAutocomplete}
          className="mt-0 border-grey-300"
        >
          {suggestions.map((itemArr: SUGGESTION_LIST_TYPE, index) => (
            <AutoCompleteItem
              key={'items' + index}
              onClick={() => routeToDetails(itemArr)}
            >
              {Object.values(itemArr)
                .filter(
                  (
                    item
                  ): item is { id: string; label: string; value: string } =>
                    typeof item === 'object' && item !== null && 'label' in item
                )
                .map((item, i) => (
                  <div className="mb-2 sm:text-base" key={'item' + i}>
                    {item.label}
                    {item.label && <span>:</span>}{' '}
                    <span className="break-all sm:font-semibold">
                      {item.value}
                    </span>
                  </div>
                ))}
            </AutoCompleteItem>
          ))}
        </AutoCompleteContainer>
      )}
    </>
  );
};
